import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForgetPasswordModel } from 'src/app/core/models/register.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  model = new ForgetPasswordModel();
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private router: Router) { }

  ngOnInit(): void {
  }

  async reset(){
    const data: any = await this.authService.getUserToken().toPromise();

    this.authService.forgotPassword(this.model, data.token).subscribe(response => {
      if (response.success) {
        this.alertService.alert("Başarılı", "Adresinize ait bir email bulunması durumunda şifre sıfırlama işleminiz mail adresinize iletilecektir!", "success");
        this.navigateToLogin();
      } else {
        this.alertService.alert("Hata", "Geçici olarak işleminiz gerçekleştirilemiyor!", "error");
      }
    });
  }

  navigateToLogin(){
    this.router.navigate(['/login']);
  }

}
